import { regexValidation } from './regex'

const placa = (str: string) => {
    return regexValidation.placa.test(str.replace(/\W/, ''))
}

const chassis = (str: string) => {
    return regexValidation.chassis.test(str.toUpperCase())
}

const ano = (str: string | number) => {
    return regexValidation.ano.test(str.toString())
}

const verifiedRenavam = (renavam: string) => {
    const length = 11
    let mod11 = 0
    let ultimoDigitoCalculado = 0

    if (renavam.match('^([0-9]{9})$')) {
        renavam = '00' + renavam
    }

    if (renavam.match('^([0-9]{10})$')) {
        renavam = '0' + renavam
    }

    if (!renavam.match('[0-9]{11}')) {
        return false
    }

    const renavamSemDigito = renavam.substring(0, 10)

    const renavamReversoSemDigito: string = renavamSemDigito
        .split('')
        .reverse()
        .join('')

    let soma = 0

    for (let i = 0; i < 8; i++) {
        const algarismo = parseInt(renavamReversoSemDigito.substring(i, i + 1))
        const multiplicador = i + 2
        soma += algarismo * multiplicador
    }

    soma += +renavamReversoSemDigito.charAt(8) * 2
    soma += +renavamReversoSemDigito.charAt(9) * 3

    mod11 = soma % length

    ultimoDigitoCalculado = length - mod11

    ultimoDigitoCalculado =
        ultimoDigitoCalculado >= 10 ? 0 : ultimoDigitoCalculado

    const digitoRealInformado = parseInt(
        renavam.substring(renavam.length - 1, renavam.length)
    )

    if (ultimoDigitoCalculado == digitoRealInformado) {
        return true
    }

    return false
}

const validation = {
    placa,
    chassis,
    verifiedRenavam,
    ano
}

export default validation
